export default {
  areProductsLoaded: 'PRODUCTS_ARE_PRODUCTS_LOADED',
  product: 'PRODUCTS_GET_PRODUCT',
  groupByCategory: 'PRODUCTS_GET_PRODUCTS_GROUPED_BY_CATEGORIES'
}
